import { useAppDispatch, useAppSelector } from 'hooks';
import { extendSession } from 'store/sessionReducer';

const formatTime = (seconds: number): string => {
    const min = Math.floor(seconds / 60);
    return `${min}min`;
};

const SessionWarningIndicator = () => {
    const dispatch = useAppDispatch();
    const { showWarning, remainingSeconds, isExtending } = useAppSelector((state) => state.session);

    if (!showWarning || remainingSeconds === null) return null;

    const handleExtend = () => {
        dispatch(extendSession());
    };

    return (
        <div className="gd-session-warn">
            <span className="gd-session-warn__time">{formatTime(remainingSeconds)}</span>
            <button type="button" className="gd-session-warn__btn" onClick={handleExtend} disabled={isExtending}>
                {isExtending ? '...' : 'Extend'}
            </button>
        </div>
    );
};

export default SessionWarningIndicator;
